// extracted by mini-css-extract-plugin
export default {"column":"DineInOrders_column__bu+Vg","icon":"DineInOrders_icon__gmpUp","dineInTable":"DineInOrders_dineInTable__utV1K"};